import { Component, OnInit } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-taskandreminderswidget',
  templateUrl: './taskandreminderswidget.component.html',
  styleUrls: ['./taskandreminderswidget.component.scss']
})
export class TaskandreminderswidgetComponent implements OnInit {

  public _taskAndReminderSettings$ = this._dashboardFacade$.taskAndReminderSettings$;
  constructor(private _dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this._dashboardFacade$.fetchTaskAndReminderSettings();
  }

}
